import React, { PureComponent } from 'react';
import styles from './GamesAutocomplete.module.scss';
import { GameItem } from './GamesAutocomplete';

interface Props {
    item: GameItem;
    onItemClick: Function;
}

class ListItem extends PureComponent<Props> {
    onItemClick = () => {
        const { item, onItemClick } = this.props;

        onItemClick(item);
    };

    render() {
        const { item } = this.props;

        return (
            <div className={styles['list-item']} onClick={this.onItemClick}>
                <div className={styles['list-item--title']}>{item.name}</div>
            </div>
        );
    }
}

export default ListItem;
